import CardTitleWithIcon from "@/components/company/card-title-with-icon";
import { Badge } from "@/components/ui/badge";
import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { useTranslation } from "@/hooks/useTranslation";
import { getFilteredDomainAliases } from "@/lib/company-data-availability";
import { CompanyDTO } from "@shaarp/common";
import { ExternalLinkIcon, GlobeIcon } from "lucide-react";

type CardDomainAliasesProps = {
  readonly company: CompanyDTO;
};

export default function CardDomainAliases({ company }: CardDomainAliasesProps) {
  const { t } = useTranslation();
  const aliases = getFilteredDomainAliases(company);

  if (aliases.length === 0) return null;

  return (
    <Card className="flex flex-col min-w-0 overflow-hidden">
      <CardHeader>
        <CardTitleWithIcon
          icon={GlobeIcon}
          title={t("company.domainAliases.title")}
        />
        <p className="text-xs text-muted-foreground pl-[52px] -mt-1">
          {t("company.domainAliases.subtitle")}
        </p>
      </CardHeader>
      <CardContent>
        <div className="flex flex-wrap gap-2">
          {aliases.map((alias) => (
            <a
              key={alias}
              href={`https://${alias.replace(/^https?:\/\//, "")}`}
              target="_blank"
              rel="noreferrer"
              className="group"
            >
              <Badge
                variant="secondary"
                className="gap-1.5 py-1 px-2.5 font-mono text-xs hover:bg-primary/10 hover:text-primary transition-colors"
              >
                {alias}
                <ExternalLinkIcon className="w-3 h-3 opacity-0 group-hover:opacity-100 transition-opacity" />
              </Badge>
            </a>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
